const INFO = {
	main: {
		title: "Anthony's Reactofolio",
		name: "Anthony S.",
		email: "anthony_suryajaya@outlook,com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/thony_surya",
		github: "https://github.com/anthony-suryajaya",
		linkedin: "https://www.linkedin.com/in/anthony-suryajaya/",
		stackoverflow: "https://stackoverflow.name/pythony",
		medium: "https://medium.com/@thony-surya",
	},

	homepage: {
		title: "Python, JavaScript Developer, and Manga Enthusiast.",
		description:
			"I am a Data Scientist with expertise in Python and TensorFlow Framework. I have experience in building scalable, and reliable Machine Learning Model for web applications using Google Cloud Platform and other technologies, such as AWS. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
  title: "Anthony's Public Resume",
  description: (
    <div>
		<h2>Summary</h2>
		<p>
			A passionate problem solver, eternal learner, and data scientist with over 12 months of experience using Python and TensorFlow to build Machine Learning models and Data Science related projects. Always applying the clean code paradigm when writing codes and successfully optimizing an automation program at Philip Morris International by achieving a 30% reduction in-app perceived loading time.
		</p>
    </div>
  ),
  education: (
    <div>
		<h2>Education:</h2>
		<p>
			<a href="https://www.its.ac.id/">Sepuluh Nopember Institute of Technology (ITS)</a><br />
			 B.Eng in Naval Architecture (2018-2022)<br />
			(GPA: 3.47/4.00)
		</p>
    </div>
  ),
  certification: (
    <div>
      <h2>Skills:</h2>
	  <h3>Technical:</h3>
	  <p>
		<ul>
			<li>Python</li>
			<li>Machine Learning</li> 
			<li>Computer Vision</li> 
			<li>Natural Language Processing (NLP)</li> 
			<li>TensorFlow</li> 
			<li>SQL</li> 
			<li>Google Cloud Platform (GCP)</li>
			<li>JavaScript</li> 
			<li>GitHub</li> 
			<li>React</li> 
			<li>AWS Sage Maker</li>
			<li>Microsoft Office</li>
			<li>Google Office Suite</li>
			<li>Google Analytics</li>
			<li>Google Firebase</li>       
		</ul>
	  </p>
	  <h3>Soft Skills:</h3>
	  <p>
		<ul>
			<li>Communication</li> 
			<li>Collaboration</li>
			<li>Management</li>
			<li>Adaptability</li>
	  	</ul>
	  </p>
	  <h3>Languages:</h3>
	  <p>
		<ul>
			<li>Bahasa Indonesia -- Native</li> 
			<li>English -- Fluent</li>
	  	</ul>
	  </p>
    </div>
  ),
  resume: 
  <div>
	<h2><a href="https://docs.google.com/document/d/1U0RPttdjRcPynr-lmMYPP3kKmpQRRO_RzGKg0ASeBWs/edit?usp=sharing">Full Resume</a></h2>
  </div>
},


	projects: [
		{
			title: "Thesis Project",
			description:
				"This is my Final Project for my final Year in University, where I combine Computer Vision for an Automatic Anti-Collision Avoidance System using RaspberryPi as the base Microprocessor",
			logo: "https://upload.wikimedia.org/wikipedia/id/c/c4/Badge_ITS.png",
			linkText: "View Project",
			link: "https://github.com/anthony-suryajaya/Tugas_Akhir",
		},

		{
			title: "Machine Learning Projects",
			description:
				"This is the Machine Learning Model I've made together with my teammates to deploy on Google's Cloud Platform for an Android Application we made together",
			logo: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Hey_Machine_Learning_Logo.png",
			linkText: "View Project",
			link: "https://github.com/anthony-suryajaya/ML-proj",
		},

		{
			title: "React Apps",
			description:
				"A collection of React based Application I do for personal Projects",
			logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
			linkText: "View Project",
			link: "https://github.com/anthony-suryajaya/react-app",
		},
		{
			title: "Python Projects",
			description:
				"A collection of Python based Application I do for personal Projects",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/anthony-suryajaya/pyproj",
		},
	],
};

export default INFO;
